import { useContext } from 'react';
import { AppContext } from '../context/AppContext';

/**
 * Custom hook to access the authentication context
 * @returns {Object} Auth context values and methods
 */
const useApp = () => {
  const context = useContext(AppContext);
  
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  
  return context;
};

export default useApp;